import { cn } from "@/modules/lib/utils"
import Union from "@images/payment/unionLogo.svg"
import { CheckmarkIcon } from "@images/svgIcons/checkmarkIcon"
import { Text } from "@/components/ui/baseUi/text"

type AdvantagesViewProps = {
  title: string
  description: string
  subtitle: string
  advantages: string[]
  className?: string
  fontSizeBig?: boolean
}

export function AdvantagesView({
  title,
  description,
  subtitle,
  advantages,
  className,
  fontSizeBig,
}: AdvantagesViewProps) {
  return (
    <div
      className={cn("flex flex-col bg-primary-100/50 bg-right bg-no-repeat", className)}
      style={{ backgroundImage: `url(${Union})` }}
    >
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-2">
          <Text fontStyle={fontSizeBig ? "HL" : "TL"}>{title}</Text>
          <Text fontStyle="BM" className="text-neutral-800">
            {description}
          </Text>
        </div>
        <div className="flex flex-col gap-8">
          <Text fontStyle={fontSizeBig ? "HS" : "BL"}>{subtitle}</Text>

          {advantages.map((value, index) => (
            <div key={index} className="flex flex-row items-center gap-4">
              <div
                className="flex items-center justify-center bg-primary-400"
                style={{
                  minWidth: fontSizeBig ? "2.5rem" : "30px",
                  minHeight: fontSizeBig ? "2.5rem" : "30px",
                  borderRadius: fontSizeBig ? "1.75rem" : "15px",
                }}
              >
                <CheckmarkIcon
                  color="currentColor"
                  style={{
                    width: fontSizeBig ? "22px" : "16px",
                    height: fontSizeBig ? "22px" : "16px",
                  }}
                />
              </div>

              <Text color="currentColor" fontStyle={fontSizeBig ? "TL" : "LL"}>
                {value}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
